'use client'

import { cn } from '@/utilities/ui'
import React from 'react'
import RichText from '@/components/RichText'
import type { LinkEmbedBlock } from '@/payload-types'
import Link from 'next/link'
import { ExternalLink } from 'lucide-react'
import { Text } from '@/components/ui/text'

interface OpenGraphData {
  title?: string
  description?: string
  image?: string
  siteName?: string
  url?: string
}

export function LinkEmbedClient({
  url,
  caption,
  className,
  og,
}: LinkEmbedBlock & {
  className?: string
  og?: OpenGraphData | null
}) {
  if (!url) {
    return null
  }

  if (!og) {
    return (
      <div className={cn('relative flex flex-col w-full', className)}>
        <div className={cn('flex justify-start w-full border border-olive-1/10 p-[10px]')}>
          <Link href={url} target="_blank" rel="noopener noreferrer" className="flex gap-[10px]">
            <ExternalLink className="w-5 h-5 flex-shrink-0" />
            {url}
          </Link>
        </div>
        {caption && (
          <div className={cn('relative pt-[10px] text-right')}>
            <RichText data={caption} enableProse={false} className="media-caption" />
          </div>
        )}
      </div>
    )
  }

  return (
    <div className={cn('relative', className)}>
      <Link href={url} target="_blank" rel="noopener noreferrer" className="relative">
        <img src={og.image} alt={og.title || 'Preview'} className="w-full h-full" />
        <div className="absolute bottom-[10px] left-[10px] bg-white !px-[5px] py-[2px] border border-olive-1/10 flex items-center">
          <Text className="!text-[12px] !font-medium">{url}</Text>
        </div>
      </Link>
      {caption && (
        <div className={cn('relative pt-[10px] text-right')}>
          <RichText data={caption} enableProse={false} className="media-caption" />
        </div>
      )}
    </div>
  )
}
